import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && e.msg) || JSON.stringify(e)).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = signed in

  const applyToken = (t) => {
    if (t) {
      localStorage.setItem("rh_token", t);
      axios.defaults.headers.common.Authorization = `Bearer ${t}`;
    } else {
      localStorage.removeItem("rh_token");
      delete axios.defaults.headers.common.Authorization;
    }
  };

  const refresh = useCallback(async () => {
    if (window.location.hash?.includes("session_id=")) return; // AuthCallback handles it
    const t = localStorage.getItem("rh_token");
    if (!t) {
      setUser(false);
      return;
    }
    axios.defaults.headers.common.Authorization = `Bearer ${t}`;
    try {
      const { data } = await axios.get(`${API}/auth/me`);
      setUser(data);
    } catch {
      applyToken(null);
      setUser(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    applyToken(data.token);
    setUser(data.user);
  };
  const register = async (name, email, password) => {
    const { data } = await axios.post(`${API}/auth/register`, { name, email, password });
    applyToken(data.token);
    setUser(data.user);
  };
  const googleExchange = async (session_id) => {
    const { data } = await axios.post(`${API}/auth/google/session`, { session_id });
    applyToken(data.token);
    setUser(data.user);
    return data.user;
  };
  const logout = async () => {
    try { await axios.post(`${API}/auth/logout`); } catch {}
    applyToken(null);
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, login, register, googleExchange, logout, refresh, setUser }}>
      {children}
    </AuthCtx.Provider>
  );
}
